import toast from "bootstrap/js/src/toast";
import {showErrorMessage} from "@/helper";

export default {
    getStatsTable(body) {
        return new Promise((resolve, reject) => {
            http.post('api/reports/stats-table', body).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    getStatsTableRowStats(params) {
        return new Promise((resolve, reject) => {
            http.get('api/reports/stats-table-row-stats', { params }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(null);
            });
        });
    },
    getStatsHistory(body) {
        return new Promise((resolve, reject) => {
            http.post('api/reports/stats-history', body).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    getTotalStats() {
        return new Promise((resolve, reject) => {
            http.get('api/reports/total-stats', {}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    getContractsTypesCountStats() {
        return new Promise((resolve, reject) => {
            http.get('api/reports/contracts-types-count-stats', {}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    getContractsTypesAmountStats() {
        return new Promise((resolve, reject) => {
            http.get('api/reports/contracts-types-amount-stats', {}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    getStrategiesCountStats() {
        return new Promise((resolve, reject) => {
            http.get('api/reports/strategies-count-stats', {}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    /** IMA-517 fáze 8: dlaždice záložky Dluhopisy (objemy po měnách). */
    getBondsSummary() {
        return http.get('api/reports/bonds/summary').then(response => response.data.data);
    },
    /** Dluhopisy, které drží klienti ve struktuře přihlášeného uživatele. */
    getBonds() {
        return http.get('api/reports/bonds').then(response => response.data.data);
    },
    /** Klienti ze struktury, kteří dluhopis drží (prázdný seznam, když nikdo). */
    getBondClients(bondId) {
        return http.get(`api/reports/bonds/${bondId}/clients`).then(response => response.data.data);
    },
    getStrategiesAmountStats() {
        return new Promise((resolve, reject) => {
            http.get('api/reports/strategies-amount-stats', {}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    
}